<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <div style="width: 50%; display: inline-flex">
            <v-icon color="#28a745">mdi-file</v-icon>
            <h4>{{ $t("messages.general.showInfo") }}</h4>
          </div>
          <div style="width: 50%; text-align: right;">
            <button
              v-if="isRedirectStatement"
              type="button"
              class="btn btn-primary btn-lg"
              style="border-radius: 0.3rem !important; background-color: rgba(11, 187, 236, 0.9) !important; border-color: rgba(11, 187, 236, 0.9)"
              @click="handleChangeLang()"
            >
              {{ $t("messages.general.chooseLang") }}
            </button>
            <span v-if="showPrint && isRedirectStatement"
              >&nbsp;&nbsp;&nbsp;</span
            >
            <button
              v-if="showPrint && isRedirectStatement"
              type="button"
              class="btn btn-primary btn-lg"
              style="border-radius: 0.3rem !important; background-color: rgba(11, 187, 236, 0.9) !important; border-color: rgba(11, 187, 236, 0.9)"
              @click="handleBack()"
            >
              {{ $t("messages.general.backhome") }}</button
            >&nbsp;&nbsp;&nbsp;
            <button
              v-if="showPrint && isRedirectStatement"
              type="button"
              class="btn btn-primary btn-lg"
              style="border-radius: 0.3rem !important; background-color: rgba(11, 187, 236, 0.9) !important; border-color: rgba(11, 187, 236, 0.9)"
              @click="handleLogout()"
            >
              {{ $t("messages.general.logout") }}
            </button>
          </div>
        </div>
        <div class="card-body">
          <div>
            <div
              v-if="appInfo.data.ISSHOW_PRINTINVOICEBUTTON == 'Y'"
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    v-if="showPrint"
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleClickQr()"
                  >
                    {{ $t("messages.general.qrcodeMobileBank") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    v-if="showPrint"
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleClickPrint()"
                  >
                    {{ $t("messages.checkRegResult.printStatementPayment") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="text-center">
                    {{ $t("messages.general.seqOrder") }}
                  </th>
                  <th class="text-center">
                    {{ $t("messages.general.feeList") }}
                  </th>
                  <th class="text-center">
                    {{ $t("messages.general.registationFee") }}
                  </th>
                  <!-- <th class="text-center">
                    {{ $t("messages.general.overdueAmout") }}
                  </th>
                  <th class="text-center">
                    {{ $t("messages.general.receiveCashBack") }}
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in financeData" :key="index">
                  <td class="text-center">
                    {{ item.SEQ }}
                  </td>
                  <td>
                    {{ item.FEEIDNAME }}
                  </td>
                  <td class="text-right">
                    {{
                      isNaN(item.BALANCE) ||
                      item.BALANCE == null ||
                      item.BALANCE == 0 ||
                      item.BALANCE == ""
                        ? ""
                        : numberFormat(item.BALANCE)
                    }}
                  </td>
                  <!-- <td class="text-right">
                    {{ numberFormat(item.BALANCE) }}
                  </td>
                  <td class="text-right">
                    {{ numberFormat(item.AMOUNT - item.BALANCE) }}
                  </td> -->
                </tr>
              </tbody>
              <tfoot>
                <td class="text-center"></td>
                <td class="text-right">
                  {{ $t("messages.general.netTotal") }}
                </td>
                <td class="text-right">
                  {{ numberFormat(financeFooterData.total) }}
                </td>
                <!-- <td class="text-right">
                  {{ numberFormat(financeFooterData.total) }}
                </td>
                <td class="text-right">
                  {{ numberFormat(financeFooterData.totalBack) }}
                </td> -->
              </tfoot>
            </table>
          </div>

          <v-dialog v-model="dialogError" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="red darken-3">
                <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
                <v-toolbar-title style="color: #ffebee;"
                  >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogError = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="red accent-1">
                <br />
                <span style="color: red;" v-html="errorText">{{
                  errorText
                }}</span>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogQrCode" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>fa-info</v-icon>
                <v-toolbar-title
                  >&nbsp;{{
                    $t("messages.general.qrcodeMobileBank")
                  }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogQrCode = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text class="text-center">
                <div style="width: 99%; margin: 0 auto">
                  <p style="font-size: medium;">
                    {{ $t("messages.general.qrMobileTitle") }}
                  </p>
                  <a :href="qrLink" :download="qrFileName">
                    <img style="width: 200px" :src="dialogQrSrc" />
                  </a>
                  <p
                    style="font-size: medium; margin-top: 15px; margin-bottom: 0 !important"
                  >
                    {{ $t("messages.general.qrMoblieReason") }}
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <iframe
            v-if="isVisible"
            :src="pdf"
            class="w-100"
            height="900"
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ClassProvider from "@/services/class_provider";
import ReportProvider from "@/services/report_provider";

const classProvider = new ClassProvider();
const reportProvider = new ReportProvider();

export default {
  name: "printStatement",
  data() {
    return {
      focus: new Date(),
      today: new Date(),
      locale: "th",
      color: "pink",
      financeData: [],
      financeFooterData: {},
      numberFormatOpt: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      dialogErrorTitle: "",
      dialogError: false,
      errorText: "",
      dialogQrCode: false,
      dialogQrSrc: "",
      qrLink: "",
      qrFileName: "qrCode.png",
      isVisible: false,
      pdf: "",
      showPrint: false
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      isRedirectStatement: "isRedirectStatement",
      userId: "getUserId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  async mounted() {
    this.tokenHealthChk();
    this.loadData();
  },
  methods: {
    ...mapActions("application", [
      "togglePreLoader",
      "tokenHealthChk",
      "clearToken",
      "setCurrentLocale"
    ]),
    async loadData() {
      this.togglePreLoader(true);
      console.log(
        "this.appInfo.data.ISSHOW_PRINTINVOICEBUTTON",
        this.appInfo.data.ISSHOW_PRINTINVOICEBUTTON
      );
      const payload = {
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.userId,
          lang: this.currentLang
        }
      };
      this.financeData = await classProvider.getFinance(payload);
      this.financeFooterData.total = 0;
      this.financeFooterData.totalBack = 0;
      if (this.financeData != undefined) {
        for (let i = 0; i < this.financeData.length; i++) {
          this.financeFooterData.total +=
            isNaN(this.financeData[i].BALANCE) ||
            this.financeData[i].BALANCE == null ||
            this.financeData[i].BALANCE == ""
              ? 0
              : this.financeData[i].BALANCE;
        }
        if (this.financeFooterData.total > 0) {
          this.showPrint = true;
        }
      }
      this.togglePreLoader(false);
    },
    numberFormat(num) {
      return Number(num).toLocaleString(this.currentLang, this.numberFormatOpt);
    },
    async handleClickPrint() {
      this.togglePreLoader(true);
      const res = await reportProvider.getReportB1({
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.userId,
          lang: this.currentLang
        }
      });
      if (res.status == 200) {
        this.isVisible = false;
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        // window.open(
        //   "web/viewer.html?file=" +
        //     encodeURIComponent(fileURL) +
        //     "&filename=" +
        //     encodeURIComponent("B1.pdf") +
        //     "&_=" +
        //     new Date().getTime()
        // );
        const e = document.createEvent("MouseEvents");
        const a = document.createElement("a");
        a.download = `invoice_${this.appInfo.data.USERCODE}.pdf`;
        a.href = fileURL;
        a.dataset.downloadurl = ["application/pdf", a.download, a.href].join(
          ":"
        );
        e.initEvent(
          "click",
          true,
          false,
          window,
          0,
          0,
          0,
          0,
          0,
          false,
          false,
          false,
          false,
          0,
          null
        );
        a.dispatchEvent(e);
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = this.$t("messages.checkRegResult.printError");
      }
      this.togglePreLoader(false);
    },
    toDataURL(url) {
      return fetch(url)
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          return URL.createObjectURL(blob);
        });
    },
    async handleClickQr() {
      this.togglePreLoader(true);
      const res = await classProvider.genqrcode({
        token: this.token,
        request: {
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          studentid: this.userId,
          lang: this.currentLang
        }
      });
      if (res.status == 200) {
        const file = new Blob([res.data], { type: "image/png" });
        this.dialogQrSrc = URL.createObjectURL(file);
        this.qrLink = URL.createObjectURL(file);
        this.dialogQrCode = true;
      }
      this.togglePreLoader(false);
    },
    handleBack() {
      this.$router.push("/redirectback");
    },
    handleLogout() {
      this.clearToken();
      this.$router.push("/redirecthome");
    },
    handleChangeLang() {
      this.setCurrentLocale();
    }
  },
  watch: {
    currentLang() {
      this.loadData();
    }
  }
};
</script>
